import { Png } from "common/assets";

export  const items = [
    {
        title: "Паспорт якості",
        src: `${Png.Certificate}`,
        srcBig: `${Png.CerfOne}`,
    },
    {
        title: "Паспорт якості",
        src: `${Png.Certificate}`,
        srcBig: `${Png.CerfTwo}`,
    },
    {
        title: "Сертифікат",
        src: `${Png.Certificate}`,
        srcBig: `${Png.CerfThree}`,
    },
]